import { render, staticRenderFns } from "./ui-chart.vue?vue&type=template&id=8b6237d6&scoped=true"
import script from "./ui-chart.vue?vue&type=script&lang=js"
export * from "./ui-chart.vue?vue&type=script&lang=js"
import style0 from "./ui-chart.vue?vue&type=style&index=0&id=8b6237d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6237d6",
  null
  
)

export default component.exports